'use client';

import { ErrorBoundaryContext } from '@/globals/errorBoundary/ErrorBoundary';
import { translateInline } from '@/globals/translate/translateInline';
import { use } from 'react';
import { ErrorMessage } from '../errorMessage/ErrorMessage';

export const CBSErrorMessage = () => {
	const error = use(ErrorBoundaryContext);

	if (error?.message.includes('403')) {
		return (
			<ErrorMessage>
				{translateInline({
					en: 'Data is currently unavailable, please try again later',
					nl: 'Data is momenteel niet beschikbaar, probeer het later nog eens.',
				})}
			</ErrorMessage>
		);
	}

	return (
		<ErrorMessage>
			{translateInline({
				en: 'Unfortunately, we could not display the graph at this time',
				nl: 'Het is op dit moment helaas niet mogelijk om de grafiek te tonen',
			})}
		</ErrorMessage>
	);
};
